module.exports = __webpack_public_path__ + "static/white_abishai-d87ba55943e164445889e6125b51dc70.png";